import { defineComponent as _defineComponent } from 'vue'
import type { SportsModuleFragment } from '@/features/onboarded-home/types';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import SportsModuleCard from '@/features/onboarded-home/components/modules/sports/SportsModuleCard.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { SportType } from '@/@types/graphql-types';
import { SportPageType } from '@/interfaces/sport-graphql';

import { getSportPageContext } from '@/helpers/sports/config';
import { useUserStore } from '@/helpers/composables/useStores';

import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'SportsModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: SportsModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const { hideHomeSportsModule } = useUserStore();

// Hardcoded for now until we display other sport types
const context = getSportPageContext({
	sport: SportType.Football,
	pageType: SportPageType.SportEvent,
});

/* TRACKING */
const {
	moduleContext,
	moduleObserveVisibility: _moduleObserveVisibility,
	trackHomeModule,
} = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
});

const moduleObserveVisibility = {
	..._moduleObserveVisibility,
	callback: (isVisible: boolean) =>
		trackHomeModule('impression', {
			spec: { label: 'sport' },
			checkArgs: isVisible,
		}),
};

function handleHideHomeSportsModule() {
	trackHomeModule('hideSportsModule');
	hideHomeSportsModule();
}

return { __sfc: true,props, hideHomeSportsModule, context, moduleContext, _moduleObserveVisibility, trackHomeModule, moduleObserveVisibility, handleHideHomeSportsModule, HiddenHorizontalScrollbar, SportsModuleCard, FadeTransition, faTimes }
}

})